module.exports = __webpack_public_path__ + "img/Hanshow.d0f2d8b7.png";